module.exports = __webpack_public_path__ + "img/mountains.4130575d.jpeg";